// extracted by mini-css-extract-plugin
export default {"button":"hp-z","reviewSort":"ip-z"};